import { create } from 'zustand';

/**
 * Current project id (Palier D1 chrome). Drives the sidebar analytics links and
 * the topbar project selector. Synced from the route when on /projects/:id and
 * persisted so the analytics nav still resolves a project on account-level pages.
 */
const STORAGE_KEY = 'silospot-current-project';

function initial(): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(STORAGE_KEY);
}

interface ProjectState {
  currentProjectId: string | null;
  setCurrentProjectId: (id: string | null) => void;
}

export const useProjectStore = create<ProjectState>((set, get) => ({
  currentProjectId: initial(),
  setCurrentProjectId: (id) => {
    // No-op when the value does not change: never notify subscribers needlessly,
    // so two reconciling effects can't ping-pong into an update loop.
    if (id === get().currentProjectId) return;
    if (typeof window !== 'undefined') {
      if (id) window.localStorage.setItem(STORAGE_KEY, id);
      else window.localStorage.removeItem(STORAGE_KEY);
    }
    set({ currentProjectId: id });
  },
}));
